var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{staticClass:"Cascader",attrs:{"size":_vm.size,"clearable":"","placeholder":_vm.placeholder || '请选择',"props":{
    expandTrigger: _vm.trigger,
  },"options":_vm.options},on:{"change":_vm.onChange},model:{value:(_vm.privateValue),callback:function ($$v) {_vm.privateValue=$$v},expression:"privateValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }